export default {
  MODAL_DESKTOP_WIDTH: 568, // in px
  MODAL_DESKTOP_HEIGHT: 600, // in px
  SCROLL_DELAY: 500,
  ENTER_KEY: 'Enter',
  LANGUAGE_SELECTOR_TAG: 'ws-language-selector',
  UPVOTE_INTERRUPTION_ID: 'automated-translations',
};
